import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, Teleport as _Teleport, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "root", {}, () => [
      _createElementVNode("div", { id: _ctx.systemId }, [
        _renderSlot(_ctx.$slots, "default")
      ], 8, _hoisted_1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.system.manualPopups, (popup, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
        (popup.addTeleport)
          ? (_openBlock(), _createBlock(_Teleport, {
              key: 0,
              to: _ctx.systemId
            }, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(popup.component), _mergeProps({
                "is-open": popup.isOpen,
                "onUpdate:is-open": ($event: any) => ((popup.isOpen) = $event)
              }, popup.props), null, 16, ["is-open", "onUpdate:is-open"]))
            ], 8, ["to"]))
          : (_openBlock(), _createBlock(_resolveDynamicComponent(popup.component), _mergeProps({
              key: 1,
              "is-open": popup.isOpen,
              "onUpdate:is-open": ($event: any) => ((popup.isOpen) = $event)
            }, popup.props), null, 16, ["is-open", "onUpdate:is-open"]))
      ], 64))
    }), 128))
  ], 64))
}